import { createFileRoute } from '@tanstack/react-router';
import { FinancePage } from '../features/finance/FinancePage';
import { validateFinanceSearch } from '../features/finance/search';

/** `/finance?tab=&year=&show=&group=&ccy=&cell=&tax_issuer=` (design B10). */
export const Route = createFileRoute('/finance')({
  validateSearch: validateFinanceSearch,
  component: FinancePage,
});
